import { ProductLine } from 'pricing-pages-ui-components/constants/ProductLine';
import { ProductLevel } from 'pricing-pages-ui-components/constants/ProductLevel';
import { useGetInferenceForPricingRedirectQuery } from '../../__generated__/chirp/com/hubspot/personalization/rpc/RecommendationAppRpc.hooks';
export const useRecommendedProduct = () => {
  const queryResult = useGetInferenceForPricingRedirectQuery();
  const {
    data,
    loading
  } = queryResult;
  return {
    recommendationResponse: data,
    loading
  };
};
export const useIsRecommendedStarterCustomerPlatform = () => {
  const {
    recommendationResponse
  } = useRecommendedProduct();
  return (recommendationResponse === null || recommendationResponse === void 0 ? void 0 : recommendationResponse.hub) === 'CRM_SUITE' && (recommendationResponse === null || recommendationResponse === void 0 ? void 0 : recommendationResponse.tier) === ProductLevel.STARTER;
};
export const useIsRecommendedSalesHubPro = () => {
  const {
    recommendationResponse
  } = useRecommendedProduct();
  return (recommendationResponse === null || recommendationResponse === void 0 ? void 0 : recommendationResponse.hub) === ProductLine.SALES && (recommendationResponse === null || recommendationResponse === void 0 ? void 0 : recommendationResponse.tier) === ProductLevel.PROFESSIONAL;
};
const ProductLineToRouteMap = {
  MARKETING: 'marketing',
  SALES: 'sales',
  SERVICE: 'service',
  OPERATIONS: 'data',
  CMS: 'content',
  CRM_SUITE: 'suite'
};
const isValidProductLineKey = hub => {
  return hub !== undefined && typeof hub === 'string' && hub in ProductLineToRouteMap;
};
export const useRecommendedRouting = () => {
  const {
    recommendationResponse,
    loading
  } = useRecommendedProduct();
  const recommendedProductLine = recommendationResponse === null || recommendationResponse === void 0 ? void 0 : recommendationResponse.hub;
  const recommendedRoute = isValidProductLineKey(recommendedProductLine) ? ProductLineToRouteMap[recommendedProductLine] : 'marketing';
  return {
    recommendedRoute,
    loading
  };
};